<template>
  <mp-box id="app-vue" class="app-vue">
    <pixel-navbar v-if="isShowMenu" />
    <mp-flex as="main" :max-h="height" class="d-flex">
      <pixel-sidebar v-if="isShowMenu" :height="height" />
      <mp-box as="section" data-id="content" w="100%" :height="height" overflow-y="scroll" bg="background">
        <router-view />
        <modal-warn-quota
          v-if="isRestrictedPage"
          :title="isRestrictedPage.title"
          is-restricted
          :is-open.sync="isModalExceed"
          :prevent-close="!isRestrictedFromSubmit"
        />
        <modal-goal-type :is-open.sync="$store.state.goals.isModalGoalType" />
      </mp-box>
    </mp-flex>
  </mp-box>
</template>
<script>
import roleMixin from '@/mixins/role';
import PixelNavbar from '@/components/layouts/PixelNavbar';
import PixelSidebar from '@/components/layouts/Sidebar';
import ModalWarnQuota from '@/views/settings/manage-user/component/ModalWarnQuota';
import ModalGoalType from '@/views/goals/component/ModalGoalType';

export default {
  name: 'MainApp',
  components: {
    PixelNavbar,
    PixelSidebar,
    ModalWarnQuota,
    ModalGoalType,
  },
  mixins: [roleMixin],
  data() {
    return {
      roleData: this.$store.getters.roleData,
      isModalExceed: false,
      restrictedPages: [
        { name: 'settings_roles_add', title: 'Create role' },
        { name: 'review_cycle_create', title: 'Create cycle' },
        { name: 'review_cycle_report_summary', title: 'Review reports' },
        { name: 'review_cycle_report_detail', title: 'Review reports' },
        { name: 'nine-box', title: '9 box reports' },
        { name: 'goals_report_summary', title: 'Goal reports' },
        { name: 'goals_report_detail', title: 'Goal reports' },
        { name: 'calibration_create', title: 'Calibration' },
        { name: 'succession_plan_create', title: 'Create succession plan' },
        { name: 'individual_development_plan_create', title: 'Create development plan' },
        { name: 'competency_assignment_create', title: 'Competency assignment' },
        { name: 'competency_group_create', title: 'Competency group' },
        { name: 'settings_template', title: 'Create template', prevent_auto: true },
        { name: 'competency_item_index', title: 'Create competency item', prevent_auto: true },
      ],
      interval: null,
    };
  },
  watch: {
    isAutoOpenModalExceed(val) {
      this.isModalExceed = val;
    },
    isHideIntercom(val) {
      if (val) {
        if (this.$intercom) this.$intercom.shutdown();
      } else {
        // Show Intercom when only if is not Kakitangan
        this.initIntercom();
      }
    },
  },
  computed: {
    isPageExist() {
      return this.$route.name;
    },
    isShowMenu() {
      return this.isPageExist && !this.$route.meta.withoutNavbar;
    },
    height() {
      if (this.isShowMenu) return 'calc(100vh - 58px)';
      return '100vh';
    },
    isQuotaRestricted() {
      return this.$store.getters.getGrantAccess?.isQuotaRestricted; // is exceed from user-profile & submit API
    },
    isRestrictedPage() {
      return this.restrictedPages.find(page => this.$route.name === page.name) || false;
    },
    isAutoOpenModalExceed() {
      // if quota exceeded after grace period & user open create pages, the MODAL WILL AUTOMATICALLY SHOWN
      // EXCEPT if create is using modal (template & competency item), it differentiate using prevent_auto...
      // we should allow user to open the index page but SHOW MODAL if click create button or after submit
      // this auto open modal is triggered when load the page (from user-profile API) or after submit (submit APIs)
      return Boolean(this.isRestrictedPage) && this.isQuotaRestricted && (this.isRestrictedPage.prevent_auto ? this.isRestrictedFromSubmit : true);
    },
    isRestrictedFromSubmit() {
      return this.$store.getters.getGrantAccess?.quotaData?.is_submit_url || false;
    },
    isHideIntercom() {
      return this.$store.state.isHideIntercom;
    },
  },
  mounted() {
    if (this.isHideIntercom && this.$intercom) this.$intercom.shutdown();
  },
  destroyed() {
    clearInterval(this.interval);
  },
  methods: {
    initIntercom() {
      if (!this.$intercomSettings.intercomActive) return;
      this.interval = setInterval(() => {
        if (localStorage.userProfile) {
          const userProfile = JSON.parse(localStorage.userProfile);
          const appId = this.$intercomSettings.intercomId;
          const name = this.userData.last_name ? `${this.userData.first_name} ${this.userData.last_name}` : this.userData.first_name;
          const role = this.roleData.find(({ id }) => id === this.userData.role)?.name || 'Employee';
          const hash = this.CryptoJS.HmacSHA256(userProfile.user.sso_id, this.$intercomSettings.intercomHash).toString();
          const data = {
            app_id: appId,
            name,
            created_at: this.userData.join_date,
            user_id: userProfile.user.sso_id,
            user_hash: hash,
            email: this.userData.email,
            company: {
              id: this.cid,
              name: userProfile.t_company_name,
              'Tax Calculation Method': '',
              'Company Size': userProfile.t_company_size,
              'Talenta Current Package': '',
            },
            'Access Role in Talenta': role,
            'Number of Employee': '',
            'Gender in Talenta': userProfile.user.gender,
            'Job Position in Talenta': userProfile.user.position,
            'Phone number in Talenta': userProfile.user.phone,
            'User ID in Talenta': userProfile.user.id,
            Location: userProfile.user.address,
            'User SSO ID': userProfile.user.sso_id,
          };
          this.$intercom.boot(data);
          clearInterval(this.interval);
        }
      }, 500);
    },
  },
};
</script>
